import {
  EditDynamicSettings,
  InvalidRuleModalProps,
  useDynamicTranslation,
} from '@k3/core'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material'
import { Stack } from '@mui/system'

const InternalInvalidRuleModal = (props: InvalidRuleModalProps) => {
  const getTranslation = useDynamicTranslation()

  return (
    <Dialog open={true} onClose={props.rejectAlternative}>
      <Stack direction="row" justifyContent="flex-start">
        <DialogTitle gutterBottom={false}>
          {getTranslation('invalidRuleModalTitle')}
        </DialogTitle>
        <EditDynamicSettings
          keys={['invalidRuleModalTitle']}
          display="dialog"
        />
      </Stack>

      <DialogContent>
        <Stack direction="row" justifyContent="flex-start">
          {getTranslation('invalidRuleModalText')}
          <EditDynamicSettings
            keys={['invalidRuleModalText']}
            display="dialog"
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button color="error" onClick={props.rejectAlternative}>
          Nein
        </Button>
        <Button color="success" onClick={props.acceptAlternative}>
          Ja
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export const InvalidRuleModal = () => (props: InvalidRuleModalProps) => {
  return <InternalInvalidRuleModal {...props}></InternalInvalidRuleModal>
}
